<template>
  <div :class="{ footer: true, big: big }">
    <div :class="{ mainCenter: true }">
      <ul>
        <li class="clearfix">
          <!--  <div class="left fl">
                        <a href="javaScript:">关于源石</a>
                        <span>|</span>
                        <a href="javaScript:">奖励计划</a>
                        <span>|</span>
                        <a href="javaScript:">联系我们</a>
                        <span>|</span>
                        <a href="javaScript:">成为作者</a>
                    </div> -->
        </li>
        <li class="clearfix">
          <div class="left fl">
            客服邮箱：kefu@yuanshixx.com 电话：010-82156292 QQ：2984543729
            2814551419
          </div>
          <a
            style="font-size:14px;cursor:pointer"
            href="https://img.yuanshixx.com/cert/wenww.jpg?tdsourcetag=s_pctim_aiomsg"
            class="right fr"
            >网络文化经营许可证 粤网文(2022] 1556-124号</a
          >
          <a
            style="font-size:14px;cursor:pointer;margin-right:15px;display:inline-block"
            href="https://img.yuanshixx.com/cert/chubw.jpg"
            class="right fr"
            >出版物经营许可证</a
          >
        </li>
        <li class="clearfix">
          <div class="left fl">
            <!-- <a
              style="font-size:14px;cursor:pointer"
              href="https://img.yuanshixx.cn/cert/icp.jpg?tdsourcetag=s_pctim_aiomsg"
              >粤B2-20191449</a
            > -->
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              href="https://beian.miit.gov.cn/"
              >粤ICP备19066655号-{{filingNum}}</a
            >
            <a
                    style="font-size:14px;cursor:pointer;margin-left:15px"
                    href="https://img.yuanshixx.com/img/20220224.jpg"
            >粤B2-20191449</a
            >
          </div>
          <div class="right fr">
            Copyright yuanshixx.com All rights reserved.
          </div>
        </li>
        <li class="clearfix">
          <!-- <div class="lef fl">出版物经营许可证 新出发京零字第海 140576号</div> -->
          <div class="right fl">
            深圳市源石信息技术发展有限公司
            地址：广东省深圳市南山区粤海街道滨海社区科技园路1002号A8音乐大厦25层2502室
          </div>
          <div class="right fr">
            <a
              target="_blank"
              style="font-size:14px;cursor:pointer"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039759"
            >
              <img style="width:18px;height:18px" src="~img/beian.png" alt="" />
              京公网安备 11010502039759号
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    big: Boolean
  },
  data() {
    return {
      fixed: false,
      // domainUrl: 'www.yuanshixx.com',
      filingNum: 3
    };
  },
  mounted() {
    // this.domainUrl = window.location.host
    if (window.location.host == 'www.yuanshixx.com') {
      this.filingNum = 1
    } else if (window.location.host == 'www.yuanshixinxi.com') {
      this.filingNum = 4
    } else if (window.location.host == 'www.yuanshixx.cn') {
      this.filingNum = 3
    } else if (window.location.host == 'www.yuanshixinxi.cn') {
      this.filingNum = 2
    }
  }
};
</script>

<style lang="stylus" scoped>
.footer
    background rgba(242, 242, 242, 1)
    padding 28px 0 31px
    line-height 20px
    margin-top 10px
    width 100%
    &.big
        background rgba(25, 31, 69, 1)
        .mainCenter
            width 1200px
            color #BCBCBC
            a
                color #BCBCBC
                font-size 18px
    &.fixed
        position fixed
        bottom 0
        left 0
    .mainCenter
        width 1016px
        margin 0 auto
        color #666666
        font-size 14px
        li
            margin 0 0 15px
            &:last-child
                margin-bottom 0
            a
                font-size 14px
                cursor pointer
        a
            color #666666
            font-size 18px
        span
            font-size 18px
            display inline-block
            margin 0 5px
        img
            width 56px
            height 21px
</style>
